import { html } from "htm/preact/index.js";
import SvgIcon from "../svg-icon/svg-icon";
import settings from "src/services/settings";
import { decode } from "he";

/**
 * @typedef {object} ReservationSummaryProps
 * @property {Date} date
 * @property {number} partySize
 * @property {string} title
 * @param {ReservationSummaryProps} props
 * @returns {import("preact").VNode}
 */
function ReservationSummary({ date, partySize, title = "" }) {
    return html`
      <div class="mx-details__summary">
          <p class="mx-details__summary-item mx-details__people">
              ${partySize} People
          </p>
          <p class="mx-details__summary-item mx-details__people">
              ${date?.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    }) ?? "-"}
          </p>
          <p class="mx-details__summary-item mx-details__time">
              ${date?.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
    }) ?? "-"}
          </p>
      </div>`;
}

export default ReservationSummary;
